import { render, staticRenderFns } from "./ModalPaciente.vue?vue&type=template&id=d5e8bc7e&scoped=true"
import script from "./ModalPaciente.vue?vue&type=script&lang=ts"
export * from "./ModalPaciente.vue?vue&type=script&lang=ts"
import style0 from "./ModalPaciente.vue?vue&type=style&index=0&id=d5e8bc7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e8bc7e",
  null
  
)

export default component.exports